export default "__VITE_ASSET__BmC91$TW__"